// packages/whiteboard/src/features/checkbox/checkbox-icons.config.ts
//
// The three selectable checkbox icons (Haken/Kreuz/Smiley). Unlike Smiley's
// 22 motifs (finished, multi-colour SVGs loaded as a `Konva.Image`), the
// checkbox keeps its existing pattern of plain Konva vector shapes drawn
// directly by `checkbox.renderer.ts` — the icon shapes themselves are tiny
// and single-coloured (white on the checked fill), so an image round-trip
// would be pure overhead. This module only owns the button ORDER (used to
// wire the `action-checkbox-icon-1..3` buttons in part9.svg) and the type;
// the actual point geometry lives in the renderer next to the box it draws
// against.
//
// Stefan, 2026-08-29.

export type CheckboxIcon = 'check' | 'cross' | 'smiley';

/** Default icon for a freshly placed checkbox — the original check mark. */
export const DEFAULT_CHECKBOX_ICON: CheckboxIcon = 'check';

/**
 * Order of the icon buttons in the options circle (part9): SVG id
 * `action-checkbox-icon-1..3` → that icon key, in this order.
 */
export const CHECKBOX_ICON_ORDER: readonly CheckboxIcon[] = ['check', 'cross', 'smiley'];
